export const STATION_NAME = 'StorySpark Sounds';
export const TRACKS = [
  { id: 'frathouse', title: 'FratHouse', artist: 'Steryo Xan', src: '/assets/frat-house.mp3' },
  { id: 'doublecup', title: 'Double Cup', artist: 'Steryo Xan', src: '/assets/double-cup.mp3' },
];
